// +----------------------------------------------------------------------
// | URL:/exhibitors-lists   name: 展商列表
// +----------------------------------------------------------------------
export default {
    //第一行，banner 下方
    "上海参展商名录":'CHINA BEAUTY EXPO EXHIBITOR LIST',
    "展商按钮":'EXHIBITORS',
    "产品按钮":'PRODUCTS',
    "我的列表":'MY LIST',
    // 搜索筛选区域
    "搜索":'SEARCH',
    "请输入搜索关键字":'PLEASE SEARCH BY KEYWORDS',
    "重置":'RESET',
    "显示":'SHOW',
    "条数":'ENTRIES',
    "了解更多信息":'FIND OUT MORE',
    "已收藏":'ADDED ',
    "加入我的收藏":'ADD TO MY LIST',
    "地区":'COUNTRIES/REGIONS',
    "行业":'SECTOR',
    "所在大厅":'HALL NO.',
    "展位号":'STAND NO.',
    "展位":'STAND',
    "类别":'SECTORS',
//     新
   "国家和地区":'COUNTRIES/REGIONS',
   "展馆":'HALL',
   "品类":'CATEGORIES',
   "活动专题":'SELECTED EXHIBITOR GROUPS',
   "公司":'COMPANY',
    "公司简介":'COMPANY INTRODUCTION',
    "产品列表":'PRODUCT LISTS',
    "品牌":'BRANDS',
    "品牌2":'BRAND',
    "价格":'PRICE',
    "工厂":'FACTORY',
    "预登记":'REGISTER TO ATTEND THE SHOW',









}